module.exports = __webpack_public_path__ + "media/coffee-preferences/main_flavor_floral-b5d10221.png";